/*
 * Project: BookingEngine
 * Module: components/booking/rooms/ExtraList.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import Select from '../../common/Select';
import '../../../static/less/extras/extra.less';
import ExtraTransfer from './ExtraTransfer';
import ExtraCard from './ExtraCard';
import {
  EXTRA_CATEGORIES, EXTRA_OPTIONAL_FIELDS, CALL_CENTER_ROLE,
} from '../../../constants';
import InfoModal from './InfoModal';
import Btn from '../../ds/atoms/btn/base';
import { IconComponent } from '../../ds/atoms/icons/iconComponent';
import { DEVICES } from '../../../actions/Booking';

const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
      <div
          className={className}
          style={{ ...style, display: 'block', left: '-18px' }}
          onClick={onClick}
      />
  );
};

const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
      <div
          className={className}
          style={{ ...style, display: 'block', right: '-30px' }}
          onClick={onClick}
      />
  );
};

const multiSlideSettings = {
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  swipe: false,
  infinite: true, // Makes it cycle
  dots: false,
  speed: 500,
  adaptativeHeight: false,
  centerMode: true,
  centerPadding: '0',
  className: 'card-slider',
};

const twoSliderSettings = {
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: true,
  swipe: false,
  infinite: true, // Makes it cycle
  dots: false,
  speed: 500,
  adaptativeHeight: false,
  centerMode: true,
  centerPadding: '0',
  className: 'card-slider',
};

const oneSlideSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  swipe: true,
  infinite: true, // Makes it cycle
  dots: false,
  speed: 500,
  adaptativeHeight: false,
  centerMode: true,
  centerPadding: '0',
  className: 'card-slider',
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
};

class ExtraList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasInvalidPromocode: false,
      selectedOption: {
        code: EXTRA_OPTIONAL_FIELDS.ROUNDTRIP,
        name: 'Round trip',
      },
      options: [
        {
          code: EXTRA_OPTIONAL_FIELDS.ONEWAY,
          name: 'One way',
        },
        {
          code: EXTRA_OPTIONAL_FIELDS.ROUNDTRIP,
          name: 'Round trip',
        },
      ],
      extra: null,
    };
    this.child = React.createRef();
    /*const width = window.innerWidth;
    if (props.isMobile) {
      this.sliderSettings = oneSlideSettings;
    } else if (props.isTabletV || props.isTabletH || (props.isDesktop && width < 1200)) {
      this.sliderSettings = props.isTabletV || (props.isTabletH && width <= 820)
        ? twoSliderSettings : multiSlideSettings;
      this.sliderSettings.swipe = true;
    } else {
      this.sliderSettings = props.isCallCenterUser ? twoSliderSettings : multiSlideSettings;
      this.sliderSettings.arrows = true;
    }
    */
    if (props.isMobile) {
      this.sliderSettings = oneSlideSettings;
    } else {
      this.sliderSettings = twoSliderSettings;
    }
  }

  componentDidUpdate() {
    const { isTabletH, isTabletV, isDesktop } = this.props;
    const width = window.innerWidth;
    if (!this.props.isCallCenterUser && (isTabletV || isTabletH || (isDesktop && width < 1200))) {
      this.sliderSettings = isTabletV || (isTabletH && width <= 820) ? twoSliderSettings : multiSlideSettings;
      this.sliderSettings.swipe = true;
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(nextProps) {
    const { isTabletH, isTabletV } = this.props;
    if (isTabletH !== nextProps.isTabletH || isTabletV !== nextProps.isTabletV) {
      this.forceUpdate();
    }
  }

  componentDidMount() {
    if (this.props.extras) {
      const transfer = this.props.extras.filter((extra) => extra.category === EXTRA_CATEGORIES.TRANSFER);
      const hasRoundTrip = transfer.some((extra) =>
        extra.type.some((type) => type.type_extra === EXTRA_OPTIONAL_FIELDS.ROUNDTRIP));
      const hasOneWayToHotel = transfer.some((extra) => extra.type.some((type) =>
        type.type_extra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOHOTEL));
      const hasOneWayToAirport = transfer.some((extra) => extra.type.some((type) =>
        type.type_extra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOAIRPORT));
      if (!hasOneWayToHotel && !hasOneWayToAirport && hasRoundTrip) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
          selectedOption: this.state.options[1],
        });
      }
    }
  }

  isAdded() {
    const { extras, cart, roomId } = this.props;
    const extraCodes = extras.map((extra) => extra.extra_code);
    return cart.cartHotel.rooms[roomId - 1].extras.some(
      (extraAdded) => extraCodes.includes(extraAdded.code),
    );
  }

  onChangeSelect(item) {
    this.setState({
      selectedOption: item,
    });
  }

  openModal = (extra) => {
    this.setState({ extra });
    this.child.current.openInfoModal();
  }

  hasRoundTripTransfer(extras) {
    const hasRoundTrip = extras.some((extra) =>
      extra.type.some((type) => type.type_extra === EXTRA_OPTIONAL_FIELDS.ROUNDTRIP));
    const hasOneWayToHotel = extras.some((extra) =>
      extra.type.some((type) => type.type_extra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOHOTEL));
    const hasOneWayToAirport = extras.some((extra) =>
      extra.type.some((type) => type.type_extra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOAIRPORT));
    return (hasOneWayToHotel || hasOneWayToAirport) && hasRoundTrip;
  }

  onClickContinue = (shouldKeepExtrasSectionOpen = false) => {
    const { roomId } = this.props;
    this.setState({ showCustomAndList: !this.state.showCustomAndList }, () => {
      this.props.onClickContinue(roomId, shouldKeepExtrasSectionOpen);
    });
  }

  onToggleCustom = () => {
    const { roomId } = this.props;
    this.props.onToggleCustom(roomId);
  }

  renderExtraCard(extras) {
    const { dispatch, roomId } = this.props;
    return (extras.map((extra) => (
      <ExtraCard
        key={extra.extra_code}
        dispatch={dispatch}
        extra={extra}
        openInfoModal={this.openModal}
        roomId={roomId}
      />
    )));
  }

  renderWithOutCarousel(extras) {
    return (
      <div className='w-full flex'>
        {this.renderExtraCard(extras)}
      </div>
    );
  }

  renderCarousel(extras) {
    return (
      <div className='carousel-extras w-full'>
        <Slider {...this.sliderSettings}>
          {this.renderExtraCard(extras)}
        </Slider>
      </div>
    );
  }

  renderButtons() {
    const { isCallCenterUser } = this.props;
    if (isCallCenterUser) {
      return null;
    }
    const isAdded = this.isAdded();
    if (isAdded === false) {
      return (
        <div className="flex flex-row w-full justify-end">
          {(<Btn className='p-3 mr-2 w-28 color-extras justify-center text-sm' variant='primary'
            onClick={() => this.onClickContinue()}>{this.context.t('SKIP')}</Btn>)}
          {/*<Btn className='btn btn-primary p-3 w-28 justify-center text-sm' onClick={() => this.onClickContinue()}>{this.context.t('Continue')}</Btn>*/}
        </div>
      );
    }
    return (
      <div className="flex flex-row w-full justify-end">
        {(<Btn className='p-3 mr-2 w-28 color-extras justify-center text-sm' variant='primary'
          onClick={() => this.onClickContinue()}>{this.context.t('CONTINUE')}</Btn>)}
        {/*<Btn className='btn btn-primary p-3 w-28 justify-center text-sm' onClick={() => this.onClickContinue()}>{this.context.t('Continue')}</Btn>*/}
      </div>
    );
  }

  renderTransfer(transfer, lang) {
    return (
      <React.Fragment>
        <div className='extra-info__title flex justify-between w-full py-2'>
          <div className='flex w-full'>
            <span>
              {this.context.t('Airport - Hotel Transportation')}
            </span>
            { this.hasRoundTripTransfer(transfer)
            && (
              <Select
                selectId="roundTrip"
                extraClass="flex radio-roundtrip ml-10"
                options={this.state.options}
                selectedValue={this.state.selectedOption}
                keyCode="code"
                lang={lang}
                onSelect={(item) => this.onChangeSelect(item)}
              />
            )}
          </div>
        </div>
        {transfer.map((extra) => (
            <ExtraTransfer
              key={extra.extra_code}
              extra={extra}
              roomId={this.props.roomId}
              typeTransfer={this.state.selectedOption.code}
              onClickContinue={this.onClickContinue}
            />
        ))}
      </React.Fragment>
    );
  }

  renderEnhanceActivities(extras, label) {
    /*const { isCallCenterUser, isMobile, isTabletV } = this.props;
    let renderCarousel = isCallCenterUser ? extras.length > 2 : extras.length > 3;
    if (isMobile) {
      renderCarousel = extras.length > 1;
    } else if (isTabletV) {
      renderCarousel = extras.length > 2;
    }*/
    return (
      <React.Fragment>
        <div className='extra-info__title flex py-2'>
          <span>
            {label}
          </span>
        </div>
        {/*renderCarousel && this.renderCarousel(extras)*/}
        {/*!renderCarousel && this.renderWithOutCarousel(extras)*/}
        {this.renderCarousel(extras)}
      </React.Fragment>
    );
  }

  render() {
    const {
      extras, lang, roomId, cart,
    } = this.props;
    const { showCustomAndList, hasToggle } = this.props;

    let promocode = cart.cartHotel.rooms[0].board.promocode_applied;
    if (promocode == null) {
      promocode = '';
    }

    let extras2 = extras;

    if (promocode === 'TRANSFER') {
      extras2 = extras.filter((extra) => extra.category !== EXTRA_CATEGORIES.TRANSFER);
    }

    if (!extras2 || !cart.amount) {
      return null;
    }
    if (extras2.length === 0) {
      return null;
    }

    const transfer = extras2.filter((extra) => extra.category === EXTRA_CATEGORIES.TRANSFER);
    const enhance = extras2.filter((extra) => extra.category === EXTRA_CATEGORIES.EXTRA);
    const activities = extras2.filter((extra) => extra.category === EXTRA_CATEGORIES.RETREAT);

    const numberOfRooms = this.props.cart.cartHotel.rooms.length;

    return (
      <React.Fragment>
        <div id={`room-extras-${roomId}`} className='room-card-list--header p-4 my-5 row justify-between'>
          <span>{`${this.context.t('Room extras').toUpperCase()}`} {numberOfRooms <= 1 ? '' : `#${roomId}`}</span>
          {hasToggle && (<div className='float-right'>
            <Btn onClick={() => this.onToggleCustom()}>
              <IconComponent icon={showCustomAndList ? 'chevron-up' : 'chevron-down'}/>
            </Btn>
          </div>)}
        </div>
        {/* eslint-disable-next-line react/no-string-refs */}
        <div ref="ExtrasList" className={`extra-card-list-front ${showCustomAndList ? '' : 'extra-card-list--hidden'}`}>
          {transfer.length > 0 && promocode !== 'TRANSFER' && this.renderTransfer(transfer, lang)}
          <div className='w-full'>
            {enhance.length > 0 && this.renderEnhanceActivities(enhance, this.context.t('Enhance your Stay'))}
            {activities.length > 0 && this.renderEnhanceActivities(activities, this.context.t('Tours and Activities'))}
            {this.renderButtons()}
          </div>
            <InfoModal
              ref={this.child}
              extra={this.state.extra}
              length={enhance[0]}
              lang={this.props.lang}
              currency={this.props.currency}
            />
          <div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ExtraList.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onClickContinue: PropTypes.func,
  showCustomAndList: PropTypes.bool,
  roomId: PropTypes.string,
  extras: PropTypes.array,
  hasToggle: PropTypes.bool,
};

export default connect((state) => ({
  lang: state.i18nState.lang,
  currency: state.booking.filterCurrency,
  cart: state.cart,
  multipleRoomStep: state.booking.multipleRoomStep,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
}))(ExtraList);
